/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A21Inputs */

const et_faq_a21 = /** @type {(inputs: Faq_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO ja digiturunduse hind Eestis algab tavaliselt 200–300 € kuus kergemate optimeerimistöödega ning ulatub 1000 €+ kuus täismahuliste kasvupakettide puhul. Täpne hind sõltub konkurentsitasemest, veebilehe seisukorrast ja eesmärkidest. ScalingWebsil algavad paketid alates 300 €/kuus ja sisaldavad Google'i nähtavust, veebilehe optimeerimist ning igakuist tulemusaruannet. Broneeri tasuta 15-minutiline konsultatsioon, et saada oma ettevõtte jaoks täpne hinnakujundus.`)
};

const en_faq_a21 = /** @type {(inputs: Faq_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO and digital marketing in Estonia typically starts from €200–300 per month for lighter optimization work, rising to €1,000+ per month for full-scale growth packages. The exact price depends on competition level, current website condition, and your goals. ScalingWebs packages start from €300/month and include Google visibility, website optimization, and monthly performance reporting. Book a free 15-minute consultation to get accurate pricing for your business.`)
};

/**
* | output |
* | --- |
* | "SEO and digital marketing in Estonia typically starts from €200–300 per month for lighter optimization work, rising to €1,000+ per month for full-scale growt..." |
*
* @param {Faq_A21Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a21 = /** @type {((inputs?: Faq_A21Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A21Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a21(inputs)
	return en_faq_a21(inputs)
});